import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMonitor = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={21} height={20} fill='none' {...props}>
    <path
      stroke='#323E54'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M5.967 1.667h9.258c2.967 0 3.708.741 3.708 3.7v5.275c0 2.966-.741 3.7-3.7 3.7H5.967c-2.959.008-3.7-.734-3.7-3.692V5.367c0-2.959.741-3.7 3.7-3.7M10.6 14.35v3.983M2.267 10.833h16.666M6.85 18.333h7.5'
    />
  </svg>
);
export default SvgMonitor;
